import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: process.env.REACT_APP_APPLICATION_INSIGHTS_KEY,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
        },
        enableCorsCorrelation: true,
        disableFetchTracking: false
    }
});
appInsights.loadAppInsights();

var enrichWithAppName = (envelope) => {
  envelope.data.App = 'Aex.Web.Departures';
};
appInsights.addTelemetryInitializer(enrichWithAppName);

const logTrace = (message, severityLevel, data) =>
   appInsights.trackTrace(
    {
      message: message,
      severityLevel: severityLevel
    },
    data);

export { reactPlugin, appInsights, logTrace };